import { EliteScoreTrends } from '../../../types/mutual-fund-detail.types'
import { getScoreConfig } from '../utils'
import { ScoreValue } from './ScoreValue'
import RenderHTML from '../../ui-components/RenderHTML'

interface StripContentProps {
  tag: EliteScoreTrends
  isElite: boolean
  score?: number
  maxScore?: number
  customContent?: React.ReactNode
  description?: string
  descriptionClassName?: string
}

export const StripContent = ({
  tag,
  isElite,
  score,
  maxScore,
  customContent,
  description,
  descriptionClassName
}: StripContentProps) => {
  const config = getScoreConfig(tag)

  return (
    <div className='flex flex-col gap-[2px]'>
      <div className='flex items-center gap-2 pb-1'>
        {customContent ? (
          <div className='flex items-center'>{customContent}</div>
        ) : (
          <ScoreValue
            numerator={isElite ? score : null}
            denominator={maxScore ?? 100}
            isLock={!isElite}
            lockColor={config.lockColor}
            textColor={config.textColor}
          />
        )}
        <span
          className='px-2 pb-[2px] h-[19px] rounded-[6px] text-[13px] font-[500] flex items-center justify-center'
          style={{ backgroundColor: config.backgroundColor, color: config.textColor }}
        >
          {config.scoreLabel}
        </span>
      </div>
      {description && (
        <div className={`text-[13px] leading-[140%] font-[400] ${descriptionClassName ?? ''}`}>
          <RenderHTML innerHTMLText={description} />
        </div>
      )}
    </div>
  )
}
